import { createI18n } from 'vue-i18n'; // v9.x
import zh from './common/zh.js';
import en from './common/en.js';
import zh_tw from './common/zh_tw.js';

// 默认语言
const defaultLang = 'zh_cn';

// 是否展示多语言设置
export const isShowLang = true;

/** 规范化语言标识 */
export function normalizeLocale(locale) {
	if (!locale) return defaultLang;
	const k = String(locale).toLowerCase().replace('-', '_');
	if (k.startsWith('zh_tw') || k.startsWith('zh_hk') || k.startsWith('zh_mo') || k.includes('hant') || k === 'tw' || k === 'hk') {
		return 'zh_TW';
	}
	if (k.startsWith('zh_cn') || k.startsWith('zh_sg') || k.includes('hans') || k === 'zh' || k === 'cn') {
		return 'zh_CN';
	}
	if (k.startsWith('en')) {
		return 'en';
	}
	return defaultLang;
}

export function getInitialLocale() {
	if (!isShowLang) {
		return defaultLang;
	}
	const loc = uni.getStorageSync('language') || uni.getStorageSync('locale') || defaultLang;
	return normalizeLocale(loc);
}

export { defaultLang };

const i18n = createI18n({
	locale: getInitialLocale(),
	fallbackLocale: 'zh_cn',
	missingWarn: false,
	fallbackWarn: false,
		silentTranslationWarn: true,  // 【修复】禁用翻译警告
		silentFallbackWarn: true,     // 【修复】禁用回退警告
	messages: {
		'en': en,
		'en-US': en,
		'en_US': en,

		'zh': zh,
		'zh_cn': zh,
		'zh-CN': zh,
		'zh_CN': zh,

		'zh_tw': zh_tw,
		'zh-TW': zh_tw,
		'zh_TW': zh_tw,
	}
});

/** 同步更新 i18n 响应式 locale 状态 */
function updateI18nLocale(locale) {
	if (i18n && i18n.global) {
		if (typeof i18n.global.locale === 'object' && i18n.global.locale && 'value' in i18n.global.locale) {
			i18n.global.locale.value = locale;
		} else {
			i18n.global.locale = locale;
		}
	}
}

/** 获取当前生效的语言代码 */
export function getCurrentLanguage() {
	if (i18n && i18n.global) {
		const loc = i18n.global.locale;
		return typeof loc === 'object' && loc && 'value' in loc ? loc.value : loc;
	}
	return getInitialLocale();
}

/**
 * 重新加载当前页面
 * @param {Number} delay - 延迟执行毫秒数，默认 100ms 确保存储写入完成
 */
export function reloadCurrentPage(delay = 100) {
	const doReload = () => {
		// #ifdef H5
		if (typeof window !== 'undefined' && window.location) {
			window.location.reload();
			return;
		}
		// #endif

		// #ifndef H5
		try {
			const pages = getCurrentPages();
			if (pages && pages.length > 0) {
				const curPage = pages[pages.length - 1];
				const route = '/' + (curPage.route || curPage.__route__ || '');
				const options = curPage.options || {};
				const query = Object.keys(options)
					.map(key => `${key}=${encodeURIComponent(options[key])}`)
					.join('&');
				const targetUrl = query ? `${route}?${query}` : route;

				uni.reLaunch({
					url: targetUrl
				});
			}
		} catch (e) {
			console.error('reloadCurrentPage 失败:', e);
		}
		// #endif
	};

	if (delay > 0) {
		setTimeout(doReload, delay);
	} else {
		doReload();
	}
}

/** 切换语言 */
export function setLanguage(lang, autoReload = false) {
	const normalized = normalizeLocale(lang);
	uni.setStorageSync('language', normalized);
	updateI18nLocale(normalized);
	uni.$emit('language-changed', normalized);
	if (autoReload) {
		reloadCurrentPage();
	}
	return normalized;
}

/** 全局翻译函数（纯函数场景，如 js 工具或 pinia store） */
export function t(key, params) {
	try {
		if (i18n && i18n.global && typeof i18n.global.t === 'function') {
			const res = i18n.global.t(key, params);
			if (res !== undefined && res !== null) return res;
		}
	} catch (e) {}
	return key;
}

/** 检查是否存在翻译键 */
export function te(key) {
	try {
		if (i18n && i18n.global && typeof i18n.global.te === 'function') {
			return i18n.global.te(key);
		}
	} catch (e) {}
	return false;
}

/** 初始化语言设置 */
export function initLanguage() {
	const current = getInitialLocale();
	uni.setStorageSync('language', current);
	updateI18nLocale(current);
	return current;
}

export default i18n;